import React from 'react'

import { CheckboxGroup } from '../checkbox-group/CheckboxGroup'
import { Tree } from '../tree/Tree'

type CheckboxTreeCollapsibleProps = Omit<
  React.ComponentProps<typeof Tree.Collapsible> &
    React.ComponentProps<typeof CheckboxGroup.Sub>,
  'asChild'
>

export const CheckboxTreeCollapsible = ({
  children,
  ...rest
}: CheckboxTreeCollapsibleProps): React.JSX.Element => {
  return (
    <CheckboxGroup.Sub asChild>
      <Tree.Collapsible {...rest}>{children}</Tree.Collapsible>
    </CheckboxGroup.Sub>
  )
}
